import noUiSlider from 'nouislider';
import wNumb from 'wNumb';

export default new class RangeSlider {
  // uislider
  init(html5Slider) {
    var min = parseInt(html5Slider.dataset.min);
    var max = parseInt(html5Slider.dataset.max);

    var minValue = parseInt(html5Slider.dataset.valuemin) ? parseInt(html5Slider.dataset.valuemin) : min;
    var maxValue = parseInt(html5Slider.dataset.valuemax) ? parseInt(html5Slider.dataset.valuemax) : max;
    var step = parseInt(html5Slider.dataset.step) ? parseInt(html5Slider.dataset.step) : 10;

    var format = wNumb({
      decimals: 0,
      thousand: '.',
    });

    noUiSlider.create(html5Slider, {
      start: [minValue, maxValue],
      step: step,
      connect: true,
      range: {
        'min': min,
        'max': max,
      },
      format: format,
    });

    var inputNumberMin = html5Slider.parentNode.querySelector('.js-range-min');
    var inputNumberMax = html5Slider.parentNode.querySelector('.js-range-max');

    html5Slider.noUiSlider.on('update', function (values) {
      inputNumberMin.value = values[0];
      inputNumberMax.value = values[1];
    });

    html5Slider.noUiSlider.on('change', function () {
      $('.js-filters').trigger('submit');
    });

    inputNumberMin.addEventListener('change', function () {
      html5Slider.noUiSlider.set([this.value, null]);
    });

    inputNumberMax.addEventListener('change', function () {
      html5Slider.noUiSlider.set([null, this.value]);
    });
  }
}
